if(document.getElementById("scroll-wrapper")){
   window.onscroll = function() {doScroll()};
}
function doScroll() {
   var scroll_el = document.getElementById("scroll");
   if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
     document.getElementById("scroll").classList.add("hidden");  
     document.getElementById("back-to-top").classList.remove("hidden");
   } else {
     document.getElementById("back-to-top").classList.add("hidden");  
     document.getElementById("scroll").classList.remove("hidden");
   }
}
function scrollToTop(){
   window.scrollTo(0,0);
}